module.exports = "/_next/static/images/dc48a22a71ff91d3276c6366accb3209-pj-woman-working@2x.jpg.webp";